import axios from '../axios-auth'

export const customerProductSaleReportService = {
    getCustomerProductSaleReport,
    getAllCustomerProductSaleReportPrint,
    getCustomerProductSaleReportByCategoryGroup,
    getCustomerProductSaleReportByCategoryGroupPrint
}

function getCustomerProductSaleReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }

    return axios.get("/auth/customer-product-sale-report", { params });
}

function getAllCustomerProductSaleReportPrint(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }

    return axios.get("/auth/customer-product-sale-report-print", { params });
}

function getCustomerProductSaleReportByCategoryGroup(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }
    if (searchParams.categoryGroupId) {
        params["categoryGroupId"] = searchParams.categoryGroupId;
    }

    return axios.get("/auth/customer-product-sale-report-by-category-group", { params });
}

function getCustomerProductSaleReportByCategoryGroupPrint(searchParams) {
    let params = {};

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }
    if (searchParams.categoryGroupId) {
        params["categoryGroupId"] = searchParams.categoryGroupId;
    }

    return axios.get("/auth/customer-product-sale-report-by-category-group-print", { params });
}